import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  title: {
    fontWeight: 500,
    fontSize: 14,
  },
};
